import create from "zustand";
import i18n from "../components/traduction/i18n";

type LanguageState = {
  language: string;
  setLanguage: (lang: string) => void;
};

export const useLanguageStore = create<LanguageState>((set) => ({
  language: "en", // Default language
  setLanguage: (lang: string) => {
    i18n.changeLanguage(lang); // Change the language in i18n
    set({ language: lang }); // Update the Zustand state
  },
}));
